const getTitleMenuDishes = (t) => [
    {
        name: t('aside-menu-item-dishes'),
        linkForRoute: "dishes"
    },
    {
        name: t('aside-menu-item-bulk-update-dishes-prices'),
        linkForRoute: "bulk-update-dishes-prices"
    },
    {
        name: t('aside-menu-item-semi-finished'),
        linkForRoute: "semi-finished"
    },
]

export {
    getTitleMenuDishes,
} 